










































import { mapGetters } from 'vuex';

export default {
    name: "OnsiteSearchProductResultItem",
    props: {
        productResult: {
            type: Object
        }
    },
    computed: mapGetters(['getTranslations'])
    
}
